export function formatPriceVnd(amount: number): string {
  return new Intl.NumberFormat('vi-VN', { maximumFractionDigits: 0 }).format(Math.round(amount));
}

/** AMOUNT_CHANGE: adjustmentAmount in API is the new total, not the delta. */
export function formatServiceFeeAdjustmentLine(adj: {
  adjustmentType: string;
  originalAmount?: number;
  newAmount?: number;
  adjustmentAmount?: number;
}): string | null {
  if (adj.adjustmentType === 'AMOUNT_CHANGE') {
    const from = adj.originalAmount;
    const to = adj.newAmount ?? adj.adjustmentAmount;
    if (from != null && to != null && from !== to) {
      return `${formatPriceVnd(from)} → ${formatPriceVnd(to)}`;
    }
    return null;
  }
  if (adj.adjustmentType === 'PARTIAL_PREPAYMENT') {
    return `Trả trước: ${formatPriceVnd(adj.adjustmentAmount ?? 0)}`;
  }
  return null;
}
